module.exports = __webpack_public_path__ + "static/media/catalyst-bg-3.9d11a17b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/catalyst-bg-3.svg
// module id = 1124
// module chunks = 0